export default __webpack_public_path__ + "static/media/Schedule1.20168f25.jpg";